import { styled } from '@mui/material/styles';

export const DashboardComponentListRowBody = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  minWidth: 0,
}));

export const DashboardComponentListMeta = styled('div')(({ theme }) => ({
  color: theme.palette.neutral[500],
  display: 'flex',
  flex: '0 0 auto',
  gap: theme.spacing(1.5),
}));
